import { useLocation } from 'react-router-dom';

const STORAGE_KEY = 'dataGridSettingsCache';

export const useDataGridSettingsCache = (enable = false) => {
  const location = useLocation();

  const getCache = () => {
    try {
      const dt = sessionStorage.getItem(STORAGE_KEY);
      if (dt) {
        return JSON.parse(dt);
      }
    } catch {
      return undefined;
    }
  };

  const clearGridCache = () => {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      return undefined;
    }
  };

  const setGridCache = (selectedId, data) => {
    if (typeof data === 'object') {
      try {
        const dt = {
          pathname: location.pathname,
          selectedId,
          data,
        };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(dt));
      } catch {
        return undefined;
      }
    }
  };

  return enable ? {
    getCache,
    setGridCache,
    clearGridCache,
  } : {};
};